'use client';

import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { Heading } from '../../ui/heading';
import { ProductBadge } from './product-badge';
import { ProductRating } from '@eliadmin/core/src/components/product/detail/product-rating';
import { getContrastYIQ } from '@eliadmin/core/src/utils/style-utils';

export function ProductHeader() {
  const selectedVariant = useVariantsStore(state => state.selectedVariant);
  const product = useVariantsStore(state => state.product);

  return (
    <div className="flex w-full flex-col items-start justify-start gap-3 sm:gap-2">
      {product?.tags &&
        product?.tags?.length > 0 &&
        product.tags.map(tag => (
          <ProductBadge
            key={tag.name}
            text={tag.name}
            background={tag.color ?? '#000000'}
            color={getContrastYIQ(tag.color ?? '#000000')}
          />
        ))}
      <Heading title={selectedVariant?.name ?? product?.name} tag="h1" />
      {(product.ratingCount ?? 0) > 0 && (
        <ProductRating rating={product.rating ?? 0} ratingCount={product.ratingCount ?? 0} />
      )}
    </div>
  );
}
